import { AUTH } from '../actionTypes';

const initialState = {
  token: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case AUTH.SUCCESS:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};
